import { memo } from 'react'
import UpAndDownThreeDots from '~components/vfx/up-and-down-three-dots'

const Loading = memo(() => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <UpAndDownThreeDots />
    </div>
  )
})

Loading.displayName = 'Loading'

export default Loading
